import styled from 'styled-components';

export const InfoCard = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .section {
    margin-bottom: 1.5rem;
  }
`;

export const CardHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
`;

export const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
`;

export const CardDescription = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const CardContent = styled.div`
  padding: 1.5rem;
`;

export const SectionTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #111827;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
`;

export const TableHeader = styled.thead`
  background-color: #f9fafb;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td`
  padding: 0.75rem;
  color: #4b5563;
  font-size: 0.875rem;

  &.font-medium {
    font-weight: 700;
  }
`;

export const List = styled.ul`
  list-style-type: disc;
`;

export const ListItem = styled.li`
  margin-bottom: 0.25rem;
  font-size: 0.875rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Alert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background-color: #f3f4f6;
  margin-bottom: 0.5rem;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AlertContent = styled.div`
  font-size: 0.875rem;
  color: #4b5563;
  flex: 1;
`;

export const EmailLink = styled.a`
  color: #3b82f6;
  font-size: 0.875rem;

  &:hover {
    color: #2563eb;
  }
`;

export const HoverText = styled.span`
  position: relative;
  cursor: help;
  text-decoration: underline dotted;
`;

export const Popup = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  width: 200px;
  text-align: center;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }
`;
